import React, { useState, useContext, useRef, useEffect} from "react";

import {BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import {novaProposta, novoItemProposta} from '../ws/ws_propostas'

import contexto from '../util/contexto'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import FormularioProposta from '../componentes/FormularioProposta'

import {buscarPedido} from '../ws/ws_pedidos'

import {carregamento} from '../componentes/Carregamento'

import {ITEM_PROPOSTA_ORIGEM_PEDIDO, MSG_ERRO_PADRAO, TELA_PRINCIPAL, TELA_MINHAS_PROPOSTAS} from '../util/constantes'

import Scroll from '../componentes/Scroll'

import {buscar_loja} from '../ws/ws_usuarios'




export default function TelaNovaProposta(){
   
	const {valorContexto} = useContext(contexto);

	const navegacao = new useNavigation();
	
	const formularioPropostaRef  = useRef(null);

	const [sincronizando, setSincronizando] = useState(true) 
	
	const [carregado, setCarregado] = useState(false) 
	
	const [pedido, setPedido] = useState(null)
	
	const [loja, setLoja] = useState(null)
	
	
	const voltar = () => {
			
		navegacao.replace(util.processaVoltar())
		
		return true;
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaNovaProposta");
		
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const buscarDados= async ()=>{

		setSincronizando(true);
		
		let aux = await buscarPedido(valorContexto.idPedido);
		
		if(util.temConteudo(aux)){
			
			setPedido(aux);

			setLoja(await buscar_loja(aux.fk_usuario))
			
			setCarregado(true)
		}
		
		setSincronizando(false)
	}

	
	useFocusEffect(React.useCallback(() => {buscarDados()}, []));
	
	
	const prepararFormulario= async ()=>{
	
		console.log("prepararFormulario");
	
		if(carregado== true && pedido!=null){
			
			let itens_preparados = []
		
			if(util.temConteudo(pedido.itens)){
				for(var item of pedido.itens)
					itens_preparados.push({"origem": ITEM_PROPOSTA_ORIGEM_PEDIDO,	
											"tipo": item.tipo, 
												"nome": item.nome, 
													"descricao": item.descricao, 
														"quantidade": item.quantidade,
															"valor_unitario": null,
																"marca": item.marca,
															"modelo": item.modelo,
														"cor": item.cor,
													"tamanho": item.tamanho,
												"observacao_pedido": item.observacao,
											"observacao":null});
			}
			

			if(formularioPropostaRef.current)
				formularioPropostaRef.current.setDados({"id": null, 
													"titulo": null,
													"descricao_pedido": pedido.descricao,
													"situacao_pedido": pedido.situacao,
													"descricao": null,
													"data_expiracao": pedido.data_expiracao,
													"valor_frete": null,
													"prazo_entrega": null,
													"prazo_servico": null,
													"forma_pagamento": null,
													"solicitante": loja!=null?loja.nome:null}, 
													itens_preparados);
		}
	}
	
	
	useEffect(() => {console.log("useEffect");prepararFormulario()}, [sincronizando]);
	
	
	async function salvar(dados){
		
		dados['id_usuario'] = valorContexto.idUsuarioAtual;
		dados['id_pedido'] = valorContexto.idPedido;
		
        let proposta  = await novaProposta(dados)

        if(proposta == null || proposta.id ==null){
                
            formularioPropostaRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }

		for (const item of dados.itens) {
			
			item['id_proposta'] = proposta.id;
			
			let retorno = await novoItemProposta(item);
			
			if(retorno==null){
				
				formularioPropostaRef.current.salvarErro(MSG_ERRO_PADRAO);
				return;
			}
		}
		
        formularioPropostaRef.current.salvarSucesso();
		
		navegacao.replace(TELA_MINHAS_PROPOSTAS)
    }
	
	
	return (
		<ViewDegradeVertical titulo="Nova Proposta" voltar={()=>voltar()}>
			{(sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 
					<FormularioProposta ref={formularioPropostaRef} salvar={salvar}/>
				</Scroll>)	
			} 
		</ViewDegradeVertical>	
	);
}